module.exports = __webpack_public_path__ + "static/media/connection.4b030f4e.svg";